import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export type BadgeTone = 'yellow' | 'purple' | 'outline' | 'neutral';

export type BadgeSize = 'sm' | 'md';

interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  size?: BadgeSize;
  className?: string;
  /** Leading icon / dot */
  leading?: ReactNode;
}

const toneStyles: Record<BadgeTone, string> = {
  yellow: 'bg-brand-yellow text-brand-purple',
  purple: 'bg-brand-purple text-white',
  outline: 'bg-transparent text-brand-purple border border-brand-purple/30',
  neutral: 'bg-brand-lightgray text-brand-purple',
};

const sizeStyles: Record<BadgeSize, string> = {
  sm: 'text-[11px] px-2.5 py-1',
  md: 'text-xs px-3 py-1.5',
};

/** Small pill label — used for categories, status chips, section kickers */
export function Badge({
  children,
  tone = 'neutral',
  size = 'sm',
  className,
  leading,
}: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full font-medium tracking-wide',
        toneStyles[tone],
        sizeStyles[size],
        className
      )}
    >
      {leading}
      {children}
    </span>
  );
}
